/**
 * Utils for the standard API envelope: { data, success, message, errors }.
 */

export interface ApiEnvelope<T> {
  data: T;
  success?: boolean;
  message?: string;
  errors?: unknown;
}

/**
 * Extracts the payload from a response (response.data or response if not wrapped).
 */
export function extractData<T>(response: unknown): T {
  if (response == null) return undefined as T;
  if (typeof response === 'object' && 'data' in response && (response as ApiEnvelope<unknown>).data !== undefined) {
    return (response as ApiEnvelope<T>).data;
  }
  return response as T;
}

/**
 * Extracts an array from a response (response.data or response if it is the array).
 */
export function extractDataArray<T>(response: unknown): T[] {
  const data = extractData(response);
  return Array.isArray(data) ? data : [];
}

/**
 * Social (following/followers): `data` pode ser um array ou página `{ users: T[] }` / `{ items: T[] }`.
 */
export function extractDataUserList<T>(response: unknown): T[] {
  const data = extractData<unknown>(response);
  if (Array.isArray(data)) return data as T[];
  if (data != null && typeof data === 'object') {
    const r = data as Record<string, unknown>;
    const users = r['users'];
    if (Array.isArray(users)) return users as T[];
    const items = r['items'];
    if (Array.isArray(items)) return items as T[];
  }
  return [];
}
